import { Columns3Icon, ListIcon } from 'assets/icons';
import Tooltips from 'components/tooltips/Tooltips';
import useText from 'hooks/useText';

const VIEWS = [
  ['list', ListIcon, 'list'],
  ['kanban', Columns3Icon, 'kanban'],
];

/**
 * The switch between a list and its kanban, as on the prototype: both views
 * side by side in one frame, the one on screen greyed in, each named by its
 * tooltip. `view` is 'list' or 'kanban'.
 */
const ViewToggle = ({ view, onChange }) => {
  const { text } = useText('viewToggle');
  return (
    <div role="group" className="flex shrink-0 rounded-lg border border-gray-200 p-0.5">
      {VIEWS.map(([id, Icon, label]) => (
        <Tooltips key={id} text={text(label)} placement="bottom">
          <button
            type="button"
            aria-label={text(label)}
            aria-pressed={view === id}
            onClick={() => view !== id && onChange(id)}
            className={`flex h-[34px] w-[34px] items-center justify-center rounded-md transition-colors ${
              view === id ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <Icon wh={18} color="currentColor" />
          </button>
        </Tooltips>
      ))}
    </div>
  );
};

export default ViewToggle;
